module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-7.30f855f7.svg";